import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { FakturisanjeComponent } from './fakturisanje.component';

import { TabsModule } from 'beyond-util';

@NgModule({
  declarations: [FakturisanjeComponent],
  entryComponents: [FakturisanjeComponent],
  exports: [FakturisanjeComponent],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TabsModule,
  ],
})
export class FakturisanjeModule {}



// WEBPACK FOOTER //
// ./src/app/pages/fakturisanje/fakturisanje.module.ts